import { MessageService } from '@philips-internal/oswald-ui-core/lib/services';

import { SituationReason } from '../approval-list/approval-list-controller';

export enum Situation {
  APPROVED = 'APPROVED',
  PENDING = 'PENDING',
  FORWARDED = 'FORWARDED',
  DISAPPROVED = 'DISAPPROVED',
  OPINION = 'OPINION',
  CLOSED = 'CLOSED'
}

function getOriginByType(type: string): string {
  switch (type) {
    case 'O':
      return MessageService.translate('approvals.type.buy-order');
    case 'S':
      return MessageService.translate('approvals.type.request-buy');
    case 'R':
      return MessageService.translate('approvals.type.request-material');
    case 'N':
      return MessageService.translate('approvals.type.invoice');
    case 'C':
      return MessageService.translate('approvals.type.purchase-quote');
    case 'L':
      return MessageService.translate('approvals.type.bidding-registration');
    default:
      return '';
  }
}

function translateSituation(situation: Situation): string {
  switch (situation) {
    case Situation.APPROVED:
      return MessageService.translate('approvals.filtered-list-approved-checkbox');
    case Situation.PENDING:
      return MessageService.translate('approvals.filtered-list-pending-checkbox');
    case Situation.FORWARDED:
      return MessageService.translate('approvals.filtered-list-forwarded-checkbox');
    case Situation.DISAPPROVED:
      return MessageService.translate('approvals.filtered-list-disapproved-checkbox');
    case Situation.CLOSED:
      return MessageService.translate('approval-list-card__indicator-waiting-response-opinion');
    case Situation.OPINION:
      return MessageService.translate('reason.waiting-response-opinion');
    default:
      return situation;
  }
}

function translateReason(reason: SituationReason): string | undefined {
  switch (reason) {
    case SituationReason.URGENT:
      return MessageService.translate('reason.urgent');
    case SituationReason.RESPONSE_OPINION:
      return MessageService.translate('reason.return-opinion');
    case SituationReason.REQUEST_OPINION:
      return MessageService.translate('reason.request-opinion');
    case SituationReason.WAITING_RESPONSE_OPINION:
      return MessageService.translate('reason.waiting-response-opinion');
    default:
      return MessageService.translate('approval.awaiting');
  }
}

export {
  getOriginByType,
  translateSituation,
  translateReason,
};
